import { useEffect, ReactNode, useRef } from 'react';
import { useHeaderContext } from '@/contexts/HeaderContext';

/**
 * Hook para registrar o header de uma página no contexto global.
 * O header será renderizado FORA do container de scroll principal,
 * garantindo que fique fixo e nunca se mova com o scroll.
 * 
 * @param header - Elemento React do header (ex: <HomeHeader />)
 */
export const usePageHeader = (header: ReactNode) => {
  const { setHeaderElement } = useHeaderContext();
  const headerRef = useRef(header);
  const hasSetRef = useRef(false);
  
  // Atualizar ref quando header mudar
  headerRef.current = header;
  
  useEffect(() => {
    // Setar header apenas uma vez na montagem
    if (!hasSetRef.current) {
      setHeaderElement(headerRef.current);
      hasSetRef.current = true;
    }
    
    // Limpar quando o componente desmontar
    return () => {
      setHeaderElement(null);
      hasSetRef.current = false;
    };
  }, [setHeaderElement]);
};
